import { render, staticRenderFns } from "./applyReturn.vue?vue&type=template&id=af23ce90&scoped=true&"
import script from "./applyReturn.vue?vue&type=script&lang=js&"
export * from "./applyReturn.vue?vue&type=script&lang=js&"
import style0 from "./applyReturn.vue?vue&type=style&index=0&id=af23ce90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af23ce90",
  null
  
)

export default component.exports